import { Clock24 } from "./Clock24";
import { SoundToggle } from "./SoundToggle";
import { CtaButton } from "./CtaButton";
import { useExperience } from "@/context/ExperienceContext";

export function LogoBadge({ className = "" }) {
  return (
    <a href="/" data-testid="header-logo-link" className={`rrb-logo-badge ${className}`} aria-label="RR&B 24 Hour Daycare home">
      <img src="/media/rrb-logo-sm.webp" alt="RR&B 24 Hour Daycare" />
    </a>
  );
}

export function SiteHeader() {
  const { scene, finale } = useExperience();
  const sceneOwnsPrimary = scene.cta === "eligibility" || finale > 0.35;
  return (
    <header className="rrb-header" data-testid="site-header">
      <LogoBadge />
      <div className="flex items-center gap-2 sm:gap-4">
        <Clock24 />
        <SoundToggle />
        <div className="hidden items-center gap-2 md:flex">
          <CtaButton kind="call" size="sm" tone="soft" testId="header-call-btn" />
          <CtaButton kind="eligibility" size="sm" tone={sceneOwnsPrimary ? "soft" : "primary"} testId="header-eligibility-btn" />
        </div>
      </div>
    </header>
  );
}
